import { IPoint } from '@esri/arcgis-rest-types';

import { SnLonLat } from '@lib/geo/helpers';

import { IQueryOptions } from '../tasks';

export function lonLatToArcGIS(lonLat: SnLonLat): Pick<IQueryOptions, 'geometry' | 'geometryType'> {
  return {
    geometry: {
      x: lonLat.lon,
      y: lonLat.lat,
      spatialReference: {
        wkid: 4326,
      },
    },
    geometryType: 'esriGeometryPoint',
  };
}

export function arcGISPointToLonLat(point: IPoint): SnLonLat {
  return new SnLonLat(point.x, point.y);
}
